module.exports = __webpack_public_path__ + "static/img/Isaac_Smith_mobile.9e8b13f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Isaac_Smith_mobile.jpg
// module id = OKrr
// module chunks = 0